import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ChargesIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.667 2.66659C11.287 2.66659 11.597 2.66659 11.8513 2.73473C12.5415 2.91967 13.0806 3.45876 13.2655 4.14895C13.3337 4.40328 13.3337 4.71327 13.3337 5.33325V11.4666C13.3337 12.5867 13.3337 13.1467 13.1157 13.5746C12.9239 13.9509 12.618 14.2569 12.2416 14.4486C11.8138 14.6666 11.2538 14.6666 10.1337 14.6666H5.86699C4.74689 14.6666 4.18683 14.6666 3.75901 14.4486C3.38269 14.2569 3.07673 13.9509 2.88498 13.5746C2.66699 13.1467 2.66699 12.5867 2.66699 11.4666V5.33325C2.66699 4.71327 2.66699 4.40328 2.73514 4.14895C2.92007 3.45876 3.45917 2.91967 4.14935 2.73473C4.40369 2.66659 4.71368 2.66659 5.33366 2.66659M6.40033 3.99992H9.60032C9.97369 3.99992 10.1604 3.99992 10.303 3.92726C10.4284 3.86334 10.5304 3.76135 10.5943 3.63591C10.667 3.4933 10.667 3.30662 10.667 2.93325V2.39992C10.667 2.02655 10.667 1.83987 10.5943 1.69726C10.5304 1.57182 10.4284 1.46983 10.303 1.40591C10.1604 1.33325 9.97369 1.33325 9.60033 1.33325H6.40033C6.02696 1.33325 5.84027 1.33325 5.69767 1.40591C5.57222 1.46983 5.47024 1.57182 5.40632 1.69726C5.33366 1.83987 5.33366 2.02655 5.33366 2.39992V2.93325C5.33366 3.30662 5.33366 3.4933 5.40632 3.63591C5.47024 3.76135 5.57222 3.86334 5.69767 3.92726C5.84027 3.99992 6.02696 3.99992 6.40033 3.99992Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="5.5"
        y1="7.5"
        x2="10.5"
        y2="7.5"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="5.5"
        y1="9.5"
        x2="10.5"
        y2="9.5"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="5.5"
        y1="11.5"
        x2="7.5"
        y2="11.5"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
}
